import { SET_SHOW_LOADER_STAUS, TOGGLE_ALERT,
  RESET_COMMON_DATA, SET_TRANSACTION_ID, SET_DEVICE_TYPE } from "../actionTypes";

const initialState = {
  transactionId: null,
  isShowLoader: false,
  showAlert: false,
  alertVarient: '',
  alertMessage: '',
  mobileDevice: ''
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_SHOW_LOADER_STAUS: {
      const { status } = action.payload;
      return {
        ...state,
        isShowLoader: status
      };
    }
    case TOGGLE_ALERT: {
      return {
        ...state,
        ...action.payload.alertInfo
      };
    }
    case RESET_COMMON_DATA: {
      return {...initialState};
    }
    case SET_TRANSACTION_ID: {
      return {
        ...state,
        transactionId: action.payload.id
      };
    }
    case SET_DEVICE_TYPE:{
      return{
        ...state,
        mobileDevice: action.payload.device
      }
    }
    default:
      return state;
  }
}
